import { Colors } from '../consts/Colors.js';
import ButtonArrow from './buttons/ButtonArrow.js';

export default class PopupLarge extends Phaser.GameObjects.Container {
    constructor(scene) {
        super(scene, scene.width / 2, scene.height / 2);
        scene.add.existing(this);
        this.scene = scene;
        this.txt = "Vous êtes de véritables Gardiens de la Méditérranée !";


        this.back = this.scene.add.rexRoundRectangle(0, 0, 1008, 363, 20, Colors.Elmt.White);
        this.add(this.back);

        let title = "Bravo, mission terminée !"
        this.title = this.scene.add.rexTagText(0, -70, title, {
            fontSize: "60px",
            fontFamily: "Binx",
            align: "center",
            color: Colors.Text.Blue,
            backgroundColor: 'transparent',
            wordWrap: { width: 924 },
        }).setOrigin(0.5);
        this.add(this.title);

        this.text = this.scene.add.rexTagText(0, 0, this.txt, {
            fontSize: "40px",
            fontFamily: "Binx",
            align: "center",
            color: Colors.Text.DarkBlue,
            backgroundColor: 'transparent',
            wordWrap: { width: 924 },
        }).setOrigin(0.5);
        this.add(this.text);

        this.btn = new ButtonArrow(this.scene, 0, 100, 336, 56, "Terminer en musique", "24px", true);
        this.add(this.btn);
        this.btn.setClickFunction(() => {
            this.scene.scene.start('Karaoke')
        })


        this.setScale(0)

    }

    launchAnim() {
        this.scene.tweens.add({
            targets: [this],
            duration: 500,
            ease: 'Cubic.easeInOut',
            scale: 1,
            onComplete: () => {
                this.scene.popupOn = true;
            }
        });
    }
}
